// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"formTable-primaryButton-bIYFx5","table":"formTable-table-2Vj0XR","thead":"formTable-thead-2DWHsS","th":"formTable-th-DFYqU-","row":"formTable-row-2wuXU3"};